export default __webpack_public_path__ + "static/media/surgical_sterilization.91162cd3.svg";